import { useQuery } from '@tanstack/react-query'
import { turfMapApi } from '../lib/api'

/** [Canvass this, CT-16/17] Who is walking this map right now. Always fresh; a warning only. */
export function useActiveCanvassing(turfMapId: string | undefined, targetDate: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['turf-maps', turfMapId, 'active-canvassing', targetDate],
    queryFn: async () => (await turfMapApi.activeCanvassing(turfMapId!, targetDate!)).data,
    enabled: enabled && !!turfMapId && !!targetDate,
    staleTime: 0,
    refetchOnWindowFocus: true,
  })
}
